import styled from 'styled-components';

import { Container } from '../../../common/Styles';

export const StartedContainer = styled(Container)(
	({ theme: { down, breakpoints } }) => `
        ${down(breakpoints.md)} {
            padding-left: 20px;
            padding-right: 20px;
        }
        padding-top: 50px;
        padding-bottom: 50px;
        `
);

export const CircularDiv = styled.span(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
              font-size: 14px;
              width: 60px;
              height: 60px;
          }
          display: flex;
          align-items: center;
          justify-content: center;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          color: #fff;
          font-size: 32px;
          font-weight: 900;
          background-image: linear-gradient(122deg, #ee5641 5%, #c2286e 83%);

      
        `
);

export const GettingStartedLabel = styled.h4(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
              font-size: 22px;
          }
          color: #3b385e;
          font-weight: 900;
          font-size: 26px;
          padding: 20px 0;
      
        `
);

export const GettingStartedInnerWrap = styled.article(
	({ theme: { down, breakpoints } }) => `
  
        ${down(breakpoints.tb)} {
            width:48%;
            margin-bottom: 40px;
        }
        ${down(breakpoints.md)} {
            width:100%;
            margin-bottom: 40px;
        }
        width: 26%;
        &:first-child{
            margin-bottom: 24px;
        }
    
      `
);
